export default __webpack_public_path__ + "static/media/hotels-and-events-map.66d9381d.png";